import React from "react";

import useTheme from "../../../../hooks/useTheme";
import { AppColumn } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import { t } from "i18next";

export function RequirementSection({
  requirementsRef,
  jobData,
}) {
  const theme = useTheme();

  return (
    <div>
      <div ref={requirementsRef} />
      {jobData?.specificRequirementsDescription && (
        <AppColumn>
          <SizedBox height={theme.spacing.contentElementPadding} />
          <AppText.SubHeading
            margins={{
              marginTop: "0px",
              marginBottom: "0px",
            }}
            fontWeight={600}
          >
            {t("jobdetail.qualifications.title")}
          </AppText.SubHeading>
          <SizedBox height={theme.spacing.elementPadding} />
          <AppText.BodyText>
            {jobData.specificRequirementsDescription}
          </AppText.BodyText>
        </AppColumn>
      )}

      {jobData?.onCallDutyDescription && (
        <AppColumn>
          <SizedBox height={theme.spacing.contentElementPadding} />
          <AppText.SubHeading
            margins={{
              marginTop: "0px",
              marginBottom: "0px",
            }}
            fontWeight={600}
          >
            {t("jobdetail.other_info.title")}
          </AppText.SubHeading>
          <SizedBox height={theme.spacing.elementPadding} />
          <AppText.BodyText>{jobData.onCallDutyDescription}</AppText.BodyText>
        </AppColumn>
      )}
    </div>
  );
}
